import { Theme, alpha, darken } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { tint } from './configurePositions.action'

export interface ConfigurePalette {
  primary: string
  primaryDark: string
  primaryLight: string
  line: string
  muted: string
  secondary: string
  pale: string
  paper: string
  surface: string
  error: string
  inputBorder: string
  success: string
  unconfigured: string
  selectedSurface: string
  hoverSurface: string
  canvas: string
  labelBorder: string
  labelText: string
  warningText: string
  warningSurface: string
  marqueeFill: string
  marqueeRemoveFill: string
}

// Resolves every color used by the configure-positions screen from the app theme tokens
export const getConfigurePalette = (theme: Theme): ConfigurePalette => {
  const primary = getThemeColor(theme, MUIThemeColors.primaryMain)
  const primaryDark = getThemeColor(theme, MUIThemeColors.primaryDark)
  const surface = getThemeColor(theme, MUIThemeColors.backgroundMain)
  const pale = getThemeColor(theme, MUIThemeColors.paleBlue)
  const error = getThemeColor(theme, MUIThemeColors.errorDark)
  return {
    primary,
    primaryDark,
    primaryLight: getThemeColor(theme, MUIThemeColors.primaryLight),
    line: getThemeColor(theme, MUIThemeColors.secondaryLight),
    muted: getThemeColor(theme, MUIThemeColors.secondaryDark),
    secondary: getThemeColor(theme, MUIThemeColors.secondaryMain),
    pale,
    paper: getThemeColor(theme, MUIThemeColors.white),
    surface,
    error,
    inputBorder: getThemeColor(theme, MUIThemeColors.inputBorder),
    success: getThemeColor(theme, MUIThemeColors.successMain),
    unconfigured: theme.palette.cadetBlue[theme.palette.mode],
    selectedSurface: tint(primary, 0.11),
    hoverSurface: alpha(primary, 0.06),
    canvas: tint(surface, 0.3),
    labelBorder: darken(pale, 0.2),
    labelText: primaryDark,
    warningText: darken(getThemeColor(theme, MUIThemeColors.warningDark), 0.4),
    warningSurface: tint(getThemeColor(theme, MUIThemeColors.warningLight), 0.12),
    marqueeFill: alpha(primary, 0.07),
    marqueeRemoveFill: alpha(error, 0.08),
  }
}
